<template>
  <q-layout view="lHh LpR lff">
    <q-header :class="[$q.dark.mode ? 'bg-grey-10' : 'bg-grey-1']">
      <q-toolbar class="flex justify-between">
        <q-btn
          id="btn-toggleDrawer"
          :color="$q.dark.mode ? 'teal-3' : 'teal-9'"
          v-bind="options.drawer"
          icon="menu"
          aria-label="Menu"
          @click="toggleDrawer"
        />

        <div>
          <q-btn
            id="btn-toggleFullscreen"
            :color="$q.dark.mode ? 'teal-3' : 'teal-9'"
            :icon="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'"
            flat
            dense
            round
            class="q-mr-sm"
            @click="$q.fullscreen.toggle()"
          />
          <q-btn
            id="btn-toggleDarkMode"
            :icon="darkModeIcon"
            :color="$q.dark.mode ? 'teal-3' : 'teal-9'"
            flat
            dense
            round
            class="q-mr-sm"
            @click="() => {
              Dark.toggle()
              onClickDarkMode()
            }"
          />
        </div>
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      class="drawer-left bg-white"
      side="left"
      :mini="!miniState"
      :width="240"
      :breakpoint="768"
      :mini-width="82"
      @click.capture="drawerClick"
    >
      <q-scroll-area style="height: 100vh; max-width: 240px;">
        <q-item-label
          header
          class="text-grey-8 text-center"
        >
          <q-img
            :src="jmLogo"
            alt="Juragan Material"
            loading="lazy"
            class="main-logo"
            :style="{
              width: {
                false: '32px'
              }[miniState] || '',
              maxWidth: '84px'
            }"
          />
        </q-item-label>

        <div class="drawer-nav">
          <q-list
            class="text-grey-9"
            padding
          >
            <div
              v-for="(list, index) in essentialLinks"
              :key="index"
            >
              <q-expansion-item
                v-if="list.children && list.children.length > 0"
                :id="setDrawerId(list.name)"
                :key="index"
                :label="list.name"
                group="menu"
                expand-separator="expand-separator"
                :default-opened="list.defaultOpen"
                @show="onExpansionCollapse"
                @hide="onExpansionCollapse"
              >
                <template #header>
                  <q-item-section
                    avatar
                    class="items-center"
                  >
                    <q-img
                      v-if="list.icon"
                      :src="require('src/assets/images/icons/' + list.icon)"
                      :alt="list.name"
                      spinner-color="primary"
                      style="height: 20px; max-width: 20px"
                    />
                    <q-icon
                      v-else
                      :id="'icon-drawerDefault-' + index"
                      name="chevron_right"
                      size="xs"
                      color="teal-9"
                    />
                  </q-item-section>
                  <q-item-section>
                    {{ list.name }}
                  </q-item-section>
                </template>

                <EssentialLink
                  v-for="(child, childIndex) in list.children"
                  :key="childIndex"
                  :to="child.url"
                  :title="child.name"
                  :active-menu="child.name"
                  :is-child="true"
                  :badge="dataBadge"
                  @click.native="child.tag === 'LOGOUT' ? onClickLogout() : null"
                />
              </q-expansion-item>
              <EssentialLink
                v-else
                :icon="list.icon"
                :to="list.url"
                :title="list.name"
                :active-menu="list.name"
              />
            </div>
          </q-list>

          <div class="mainLayout__feedback">
            <q-btn
              id="mainLayout-feedback-btn"
              v-bind="options.btnRound"
              class=" row items-center justify-center q-pa-xs"
              :class="miniState ? 'mainLayout__feedback-btn' : ''"
              @click="showDrawer = true"
            >
              <q-icon
                id="mainLayout-feedback-btn-icon"
                :name="'img:' + iconMailbox"
                size="32px"
              />

              <p
                v-if="miniState"
                class="mainLayout__feedback-btn-text text-primary q-mb-none q-pl-sm"
              >
                Kotak Suara
              </p>
            </q-btn>
          </div>
        </div>
      </q-scroll-area>
    </q-drawer>

    <FeedbackForm
      :show-drawer="showDrawer"
      @closeDrawer="showDrawer = false"
    />

    <q-page-container>
      <router-view />
    </q-page-container>

    <q-footer
      class="copyright bg-transparent text-grey-6 text-center text-caption"
    >
      <q-toolbar class="justify-center">
        &copy; {{ new Date().getFullYear() }} PT. Aneka Juragan Material. All Rights Reserved
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>

<script>
import { options } from 'src/component-options'
import { LocalStorage, Dialog, Dark } from 'quasar'
import EssentialLink from 'src/components/EssentialLink.vue'
import AllRoutes from 'src/router/routes'
import { mapState } from 'vuex'
import { setActiveMenu, textToCamelCase } from 'src/helpers'
import { axios } from 'src/boot/axios'
import FeedbackForm from 'src/components/FeedbackForm.vue'

export default {
  name: 'MainLayout',

  components: {
    EssentialLink,
    FeedbackForm
  },

  data () {
    return {
      options,

      iconMailbox: require('src/assets/images/icons/mail-box.svg'),
      showDrawer: false,

      leftDrawerOpen: true,
      miniState:
        LocalStorage.getItem('drawer') !== undefined && window.innerWidth > 768
          ? LocalStorage.getItem('drawer')
          : false,
      Dark,
      essentialLinks: [],
      dataBadge: null,
      isDesktop: true
    }
  },

  computed: {
    ...mapState(['lang', 'wording']),

    darkModeIcon: () => {
      return Dark.mode ? 'light_mode' : 'dark_mode'
    },

    jmLogo () {
      return require('src/assets/images/' +
        {
          true: 'juragan-material-logo.svg',
          false: 'juragan-material-logo-gram.svg'
        }[this.miniState]
      )
    }
  },

  watch: {
    '$route.name': {
      handler (val) {
        setActiveMenu(this.$route.meta.name)
      }
    },
    '$route.query': {
      handler (val) {
        setActiveMenu(this.$route.meta.name)
      }
    }
  },

  async mounted () {
    // ---------------
    // CEK RESIZE WIDTH SCREEN
    // ---------------
    window.addEventListener('resize', this.onResize)

    this.$q.dark.set(LocalStorage.getItem('dark'))
    this.onClickDarkMode()
    this.miniState = LocalStorage.getItem('drawer')

    // ---------------
    // TOGGLE DRAWER SHORTCUT - CONTROL + B
    // ---------------
    const toggleDrawer = () => {
      return this.toggleDrawer()
    }
    document.onkeyup = function (e) {
      if (e.ctrlKey && (e.key === 'b' || e.key === 'B')) {
        toggleDrawer()
      }
    }

    const routeName = this.$route.name

    this.setEssentialLinks(routeName)
      .then((result) => {
        this.essentialLinks = LocalStorage.getItem('module') ? LocalStorage.getItem('module') : []
      })
      .then(() => {
        setActiveMenu(this.$route.meta.name)
      })

    // ---------------
    // GET NOTIF
    // ---------------
    this.fetchNotif(`${this.$store.state.endpoint.sku}/notif`, 'WAITING')
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    onResize () {
      this.isDesktop = window.innerWidth > 768
    },

    setEssentialLinks (routeName) {
      return new Promise((resolve) => {
        const check = (arr, key) => {
          return JSON.stringify(arr).indexOf(`"name":"${routeName}"`) > -1
        }

        const mainRoutes = AllRoutes[0].children.find(
          (r) => r.meta.type === 'main'
        ).children
        const normalizedRoutes = mainRoutes.map((r) => {
          // r.defaultOpen = r.children && Array.isArray(r.children)
          r.defaultOpen = check(r, routeName)

          if (r.children) {
            const children = r.children.map((c) => ({
              ...c,
              path: `${r.path}/${c.path}`
                .replace(/\/+/g, '/')
                .replace(/\/+$/, '')
            }))
            const subMenu = children.filter((r) => r?.meta?.subMenu)
            return {
              ...r,
              ...(r.meta.collapse === undefined && {
                path: r.children[0].path
              }),
              meta: {
                ...r.meta,
                title: r.meta.collapse ? r.meta.title : children[0].meta.title,
                icon: r.meta.collapse ? r.meta.icon : children[0].meta.icon
              },
              children: subMenu
            }
          }
          return r
        })

        const allowedModules = LocalStorage.getItem('module').map(
          (mod) => mod.tag
        )
        const linkFromModules = normalizedRoutes.reduce((acc, curr) => {
          const parent = allowedModules.find((p) => p.startsWith(curr.meta.tag))
          const children =
            curr.children &&
            curr.children.filter((c) =>
              allowedModules.some((mod) => mod === c.meta.tag)
            )
          if (parent !== undefined || children?.length > 0) {
            acc.push({ ...curr, children })
          }
          return acc
        }, [])

        resolve(linkFromModules)
      })
    },

    onClickLogout () {
      const { confirm } = this.wording[this.lang]

      Dialog.create({
        title: confirm.title,
        message: confirm.logout,
        cancel: 'Batal'
      }).onOk(() => {
        this.$store.dispatch('auth/LOGOUT')
      })
    },

    toggleDrawer () {
      this.onResize()

      if (this.isDesktop && !!this.isDesktop) {
        this.leftDrawerOpen = true
        this.miniState = !this.miniState
      } else {
        this.leftDrawerOpen = true
        this.miniState = true
      }

      this.$nextTick(() => {
        LocalStorage.set('drawer', this.miniState)
      })
    },

    onClickDarkMode () {
      LocalStorage.set('dark', Dark.mode)
      setActiveMenu(this.$route.meta.name)

      document.body.style.setProperty('--q-color-primary', Dark.mode ? '#26A69A' : '#006664')
      document.body.style.setProperty('--q-color-blue', Dark.mode ? '#4890c6' : '#0264AD')
      document.body.style.setProperty('--q-color-accent', Dark.mode ? '#c6acff' : '#5732A7')
    },

    setDrawerId (val) {
      return textToCamelCase(val)
    },

    onExpansionCollapse (val) {
      if (val) {
        setActiveMenu(this.$route.meta.name)
      }
    },

    async fetchNotif (endpoint, status) {
      await axios.get(`${endpoint}?product_add_status=${status}`)
        .then(response => {
          const { data: { data } } = response
          this.dataBadge = data.total
        })
        .catch(error => {
          this.$store.dispatch('notify/FETCH_ERROR', error)
        })
    },

    drawerClick (e) {
      const parent = e.target.closest('.q-expansion-item')
      if (parent && !!parent) {
        if (!parent.classList.contains('q-expansion-item--expanded')) parent.click()
        if (!this.miniState) {
          this.miniState = true
          e.stopPropagation()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .main-logo {
    .q-img__image {
      transition: none;
    }

    .body--dark & {
      filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7429%) hue-rotate(357deg) brightness(114%) contrast(99%);
    }
  }

  .drawer-left {
    .q-drawer__content {
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
    }

    .q-scrollarea {
      &__content {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }

    .btn-perbaharuan-juragan {
      border-radius: 0;
      padding: 1rem 2px;
      font-size: 10px;

      .q-btn__wrapper {
        padding: 0
      }
    }

    .q-drawer--standard {
      .btn-perbaharuan-juragan {
        font-size: 12px;
      }
    }
  }

  .drawer-nav {
    height: 100%;
    display: flex;
    flex-direction: column;

    .q-item {
      color: var(--q-color-dark);
      min-height: 30px;

      &__section--side {
        > .q-avatar {
          font-size: 24px;
        }
        > .q-icon {
          font-size: 16px;
        }
      }

      &__section--avatar {
        filter: grayscale(1);
        opacity: 0.5;
      }

      &__section--main {
        font-size: 12px;
      }

      &.q-router-link--active,
      &--active {
        color: inherit;
      }
    }

    .menu-active {
      background-color: #eef5f500;
      color: var(--q-color-primary) !important;
      font-weight: bold;

      &.q-router-link--active {
        .q-item__section--avatar {
          filter: grayscale(0);
          opacity: 1;
        }
      }
    }

    .q-expansion-item {
      &__content {
        .q-item__section--main {
          font-size: 10px;
        }

        .q-item {
          padding-top: 0;
          padding-bottom: 0;
          min-height: 38px;

          &__section--avatar {
            position: relative;

            &::before,
            &::after {
              content: '';
              border-left: solid 1px #999;
              position: absolute;
            }

            &::before {
              top: 0;
              bottom: 50%;
            }
            &::after {
              top: 50%;
              bottom: 0;
            }
          }

          &:first-child {
            .q-item__section--avatar::before {
              display: none
            }
          }

          &:last-child {
            .q-item__section--avatar::after {
              display: none
            }
          }
        }
      }

      &.expansion-active {
        .q-expansion-item__container {
          > .q-item.q-link {
            color: var(--q-color-primary) !important;
            font-weight: bold;
          }
        }
        .q-item__section--avatar {
          filter: grayscale(0);
          opacity: 1;
        }
      }
    }

    .body--dark & {
      .q-item {
        color: #fff;

        .q-item__section--avatar {
          filter: grayscale(1) brightness(10);
        }
      }

      .menu-active {
        background-color: #00666400;
        color: var(--q-color-secondary) !important;

        &.q-router-link--active {
          .q-item__section--avatar {
            filter: none;
          }
        }
      }

      .q-expansion-item.expansion-active {
        .q-expansion-item__container {
          > .q-item.q-link {
            color: var(--q-color-secondary) !important;
          }
        }
        .q-item__section--avatar {
          filter: grayscale(0);
          opacity: 1;
        }
      }
    }

    &-info {
      margin-top: auto;

      &-wide {
        padding: 1rem;
        background-color: #E6F0F0;
        border-radius: .75rem;
        margin: 0 1rem 1rem;

        header {
          margin-bottom: .5rem;
        }

        a {
          display: flex;
          margin-bottom: .325rem;
          align-items: center;
          text-decoration: none;
        }

        .q-icon {
          margin-right: 5px;
        }
      }

      &-mini {
        text-align: center;
        display: flex;
        justify-content: center;

        .q-icon {
          cursor: pointer;
        }
      }
    }
  }

  .q-drawer-container {
    &:not(.q-drawer--mini-animate) {
      .q-drawer--mini {
        .q-item {
          &, &__section {
            min-width: 57px;
          }
        }

        .q-item__label {
          display: block
        }

        .q-item__section--side {
          ~ .q-item__section--side {
            display: block;
            position: absolute;
            right: 0;
            text-align: right;

            .q-icon {
              transform: rotate(-90deg) scale(0.75);
            }
          }
        }
      }
    }
  }

  .q-footer {
    &.copyright {
      z-index: 0
    }
  }

  .mainLayout {
    &__feedback {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      margin-top: auto;
      &-btn {
        padding: 8px 12px;
        background-color: #E6F0F0;
        border-radius: 8px !important;
        width: 100%;
        &-text {
          text-decoration: underline;
          font-weight: 500;
        }
      }
    }
  }
</style>
